import { createContext, useContext } from "react"
import { RootStore } from "./stores/Root"

export const RootCtx = createContext<RootStore | null>(null)
export const useRootStore = () => {
    const store = useContext(RootCtx)
    if (!store) throw new Error(`Must call use hook for RootStore in context`)
    return store
}